import React from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import {
  AppBar,
  Toolbar,
  Grid,
  IconButton,
  Avatar,
  MenuItem,
  ListItemIcon,
  Menu,
  Box,
  useMediaQuery,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function Header(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const user = useSelector((state) => state.user);
  const { onDrawerToggle } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <AppBar
        color="primary"
        position="sticky"
        elevation={0}
        sx={{ height: "6vh" }}
      >
        <Toolbar>
          <Grid container spacing={1} alignItems="center">
            {props.showBack && (
              <Grid item>
                <IconButton
                  color="inherit"
                  edge="start"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <ArrowBackIcon sx={{ fontSize: 30 }} />
                </IconButton>
              </Grid>
            )}
            <Grid item xs />
            <Grid item>
              <Box
                component={"img"}
                sx={{ height: "15vh", width: "auto" }}
                src={require("../../images/logoDivergentes.png")}
              />
            </Grid>
            <Grid item xs />
          </Grid>
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
}

Header.propTypes = {
  onDrawerToggle: PropTypes.func.isRequired,
};

export default Header;
